<template>
  <div class="container-fluid">
    <span class="resize-loading" v-if="!communication">
      <span class="loader"></span>
    </span>
    <div v-if="communication" class="elite-tabs-wrapper">
      <tabs
        fill
        class="flex-column flex-md-row"
        tabNavWrapperClasses="nav-wrapper"
        tabNavClasses="nav elite-tabs"
        value="global"
        v-model="activeTab"
      >
        <tab-pane title="global" id="1" :active="true">
          <span slot="title">
            <i class="ni ni-cloud-upload-96"></i>
            {{ $t("COMMON.GLOBAL") }}
          </span>
          <communication-view-global v-if="alreadyLoadedTabs.includes('1')"
            v-show="activeTab === '1'" :communication="communication" />
        </tab-pane>

        <tab-pane title="gallery" id="2">
          <span slot="title">
            <i class="fas fa-images"></i>
            {{ $t("COMMON.ATTACHEMENTS") }}
          </span>
          <communication-view-attachements v-if="alreadyLoadedTabs.includes('2')"
            v-show="activeTab === '2'" :communication="communication" />
        </tab-pane>

        <tab-pane title="communication" id="3">
          <span slot="title">
            <i class="fab fa-accusoft"></i>
            {{ $t("CONTACTS.PROPERTIES") }}
          </span>
          <communication-property-list-table v-if="alreadyLoadedTabs.includes('3')"
            v-show="activeTab === '3'" :filterCommunication="communication?.id" />
        </tab-pane>

        
      </tabs>
    </div>
  </div>
</template>

<script>
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
  Select,
  Option,
  Button,
} from "element-ui";
import requestErrorMixin from "@/mixins/request-error-mixin";
import { Tabs, TabPane } from "@/components";
import CommunicationViewGlobal from "../partials/CommunicationViewGlobal.vue";
import CommunicationViewAttachements from "../partials/CommunicationViewAttachements.vue";
import CommunicationPropertyListTable from "../partials/CommunicationPropertyListTable.vue";

export default {
  layout: "DashboardLayout",

  components: {
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
    Tabs,
    TabPane,
    CommunicationViewGlobal,
    CommunicationViewAttachements,
    CommunicationPropertyListTable,
  },

  mixins: [requestErrorMixin],

  props: {
    communicationId: {
      type: [String, Number],
      required: true,
    },
  },

  data() {
    return {
      communication: null,
      activeTab: '1',
      alreadyLoadedTabs: ['1']
    };
  },

  computed: {},

  watch: {
    activeTab(newTab) {
      if (!this.alreadyLoadedTabs.includes(newTab)) {
        this.alreadyLoadedTabs.push(newTab);
      }
    }
  },

  created() {
    this.get();
  },

  methods: {
    async get() {
      try {
        await this.$store.dispatch("communications/get", this.communicationId);
        this.communication = this.$store.getters["communications/communication"];
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },
  },
};
</script>
